var _a;
/*
<Overlay />
<Modal>
  <Header>
    <HeaderText />
    <HeaderButtonContainer />
  </Header>
  <Body />
  <Footer />
</Modal>
*/
import { body, footer, header, headerText, large, modal, overlay, overlayOpenBody, small } from '../styles/legacy';
import { body as bodyCitrus2022, footer as footerCitrus2022, header as headerCitrus2022, headerText as headerTextCitrus2022, large as largeCitrus2022, modal as modalCitrus2022, overlay as overlayCitrus2022, small as smallCitrus2022, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
import { injectGlobal } from 'emotion';
export var modalOverlayOpenBodyIdentifier = 'pcty-fa915ce-modal-overlay-open';
var globalRules = (_a = {},
    _a[".".concat(modalOverlayOpenBodyIdentifier)] = overlayOpenBody,
    _a);
injectGlobal(globalRules);
export var Body = citrusStyled.div('body', { legacy: body, citrus2022: bodyCitrus2022 });
export var Footer = citrusStyled.div('footer', { legacy: footer, citrus2022: footerCitrus2022 });
export var Header = citrusStyled.div('header', { legacy: header, citrus2022: headerCitrus2022 });
export var HeaderButtonContainer = citrusStyled.div('N/A', null);
export var HeaderText = citrusStyled.h1('headerText', { legacy: headerText, citrus2022: headerTextCitrus2022 });
export var Modal = citrusStyled.div('modal', { legacy: modal, citrus2022: modalCitrus2022 });
export var Overlay = citrusStyled.div('overlay', { legacy: overlay, citrus2022: overlayCitrus2022 });
export var Small = citrusStyled.div('small', { legacy: small, citrus2022: smallCitrus2022 });
export var Large = citrusStyled.div('large', { legacy: large, citrus2022: largeCitrus2022 });
export var Styled = {
    Body: Body,
    Footer: Footer,
    Header: Header,
    HeaderButtonContainer: HeaderButtonContainer,
    Modal: Modal,
    Overlay: Overlay,
};
